import userToken from 'helpers/userToken'
export default function currentUser() {
	var jwtDecode = require('jwt-decode')
	try {
		let token = userToken()
		if(!token) return false
		var user = jwtDecode(token)
		if(user?.modules?.[0] === '*') user.super = true
		return user
	}
	catch(e) {
		console.log(e)
	}
}